/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UniversalTrackerApi } from '../../sdk/services';
import { UniversalTracker } from '../../lib/wwg.classes';
import { findIndex as _find } from 'lodash';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-add-universal-tracker-dialog',
  templateUrl: './add-universal-tracker-dialog.component.html',
  styleUrls: ['./add-universal-tracker-dialog.component.scss']
})
export class AddUniversalTrackerDialogComponent implements OnInit {
  trackers: Array<any> = [];
  items = new Array<UniversalTracker>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddUniversalTrackerDialogComponent>,
    private notificationService: NotificationService,
    private universalTrackerApi: UniversalTrackerApi) { }

  ngOnInit() {
    this.universalTrackerApi.list().toPromise().then((response: any) => {
      this.items = response.data;
      this.data.universalTrackers.forEach((item) => {
        const id = _find(this.items, function(o) { return o._id === item._id; });
        this.trackers.push(this.items[id]);
      });
    }).catch(this.notificationService.errorHandler);
  }

  addTracker() {
    this.dialogRef.close(this.trackers);
  }
}
